import React from 'react';

const Attachment = (props) => {
  return (
    <svg
      width="20"
      height="11"
      viewBox="0 0 20 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.5 11C4.04131 11 2.64236 10.4205 1.61091 9.38909C0.579463 8.35764 0 6.95869 0 5.5C0 4.04131 0.579463 2.64236 1.61091 1.61091C2.64236 0.579462 4.04131 0 5.5 0H16C17.0609 0 18.0783 0.421427 18.8284 1.17157C19.5786 1.92172 20 2.93913 20 4C20 5.06087 19.5786 6.07828 18.8284 6.82843C18.0783 7.57857 17.0609 8 16 8H7.5C6.83696 8 6.20107 7.73661 5.73223 7.26777C5.26339 6.79893 5 6.16304 5 5.5C5 4.83696 5.26339 4.20107 5.73223 3.73223C6.20107 3.26339 6.83696 3 7.5 3H15V4.5H7.5C7.23478 4.5 6.98043 4.60536 6.79289 4.79289C6.60536 4.98043 6.5 5.23478 6.5 5.5C6.5 5.76522 6.60536 6.01957 6.79289 6.20711C6.98043 6.39464 7.23478 6.5 7.5 6.5H16C16.3283 6.5 16.6534 6.43534 16.9567 6.3097C17.26 6.18406 17.5356 5.99991 17.7678 5.76777C17.9999 5.53562 18.1841 5.26002 18.3097 4.95671C18.4353 4.65339 18.5 4.3283 18.5 4C18.5 3.6717 18.4353 3.34661 18.3097 3.04329C18.1841 2.73998 17.9999 2.46438 17.7678 2.23223C17.5356 2.00009 17.26 1.81594 16.9567 1.6903C16.6534 1.56466 16.3283 1.5 16 1.5H5.5C4.43913 1.5 3.42172 1.92143 2.67157 2.67157C1.92143 3.42172 1.5 4.43913 1.5 5.5C1.5 6.56087 1.92143 7.57828 2.67157 8.32843C3.42172 9.07857 4.43913 9.5 5.5 9.5H15V11H5.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Attachment;
